import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Card,
  Alert,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import * as yup from "yup";
import { TxTable } from "../../components/Tables";
import LoadingComponent from "../../components/LoadingComponent";
import { useModalWrapper } from "../../components/ModalWrapperProvider";
import FileUpload from "../../utils/fileUpload";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import Select from "react-select";
import useTx from "../../hooks/tx.hook";
import { errorToast } from "../../utils/toast";
import ALL_MONTHS from "../../utils/constValues";

function UploadTxFileModal({handleSubmit}){
    const current_date = new Date();
    const [disabled, setDisabled] = useState(true);
    const [uploadedFile, setUploadFile] = useState(null);
    const [isDataBeingProcessed, setIsDataBeingProcessed] = useState(false);

    const dateSchema = yup.object({
        tx_month: yup
        .number()
        .required('Debes especificar el mes del archivo de operativa a subir')
        .min(1)
        .max(12),
        tx_year: yup
        .number()
        .required('Debes especificar el año del archivo de operativa a subir')
        .min(2000, 'El archivo de operativa debe ser del año 2000 o más tarde'),
    })

    const formikFileDate = useFormik({
        initialValues:{
            tx_month: current_date.getMonth() + 1,
            tx_year: current_date.getFullYear()
        },
        validationSchema: dateSchema,
        onsubmit: (values) => {
            //handleSubmit()
        }
    })

    useEffect(()=>{
        if(uploadedFile !== null){
            setDisabled(false)
        }
    }, [uploadedFile])
    return (
        <>
            <Row className="justify-content-center">
              {isDataBeingProcessed && (
                   <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
              )}
                <Col xs={12}>
                    <Card>
                        <Card.Header>
                            <Row>
                                <Col>
                                    <Alert variant={"info"} style={{ margin: "15px" }}>
                                        Sube el archivo de operativa del mes <b> de todos los afiliados </b> a generar los reportes
                                    </Alert>
                                </Col>
                            </Row>
                        </Card.Header>
                        <Card.Body>
                            <FileUpload
                                filesCallback={(e) => {
                                    setUploadFile(e)
                                }}
                            />
                            <Form style={{ padding: "10px" }}>
                            <Form.Label>Mes de operaciones</Form.Label>
                                <InputGroup>
                                    <Select
                                        id="filemonth"
                                        className="form-control"
                                        classNamePrefix="select"
                                        defaultValue={
                                            ALL_MONTHS.filter((monthObj) => monthObj.value === formikFileDate.values.tx_month)
                                        }
                                        name="month"
                                        onChange={(e)=>{
                                            formikFileDate.setFieldValue('tx_month',e.value)
                                        }}
                                        options={ALL_MONTHS}
                                    />
                                </InputGroup>
                                <Form.Label>Año de operaciones</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        id="tx_year"
                                        type="number"
                                        min="2000"
                                        max={current_date.getFullYear()}
                                        className={` ${
                                        formikFileDate.touched.tx_year && formikFileDate.errors.tx_year
                                            ? "invalid"
                                            : ""
                                        } ${
                                        formikFileDate.touched.tx_year && !formikFileDate.errors.tx_year ? "valid" : ""
                                        }`}
                                        value={formikFileDate.values.tx_year}
                                        onChange={formikFileDate.handleChange}
                                        onBlur={formikFileDate.handleBlur}
                                    />
                                </InputGroup>
                            </Form>
                        </Card.Body>
                        <Card.Footer>
                            <Button
                                variant="primary"
                                type="button"
                                className="w-100"
                                disabled={disabled}
                                onClick={(e)=>{
                                    Swal.fire({
                                        title: '¿Estas seguro que ese es el mes?',
                                        showCancelButton: true,
                                        confirmButtonText: 'Subir',
                                        cancelButtonText: `Cancelar`,
                                      }).then((result) => {
                                        /* Read more about isConfirmed, isDenied below */
                                        if (result.isConfirmed) {
                                          setIsDataBeingProcessed(true);
                                          handleSubmit({month: formikFileDate.values.tx_month, year:formikFileDate.values.tx_year, file: uploadedFile}).then((result) => {
                                            setIsDataBeingProcessed(false);
                                          })
                                        }
                                      })
                                }}
                            >
                                Subir operativa
                            </Button>     
                        </Card.Footer>                   
                    </Card>
                </Col>
            </Row>
        </>
    )
    
}

function TxPage() {
  const [isTxDataLoading, setIsTxDataLoading] = useState(false);
  /* eslint-disable no-unused-vars */
  const [wasSearched, setWasSearched] = useState(false);
  /* eslint-enable no-unused-vars */
  const { showModal, hideModal } = useModalWrapper();
  const { uploadTxFile } = useTx();

  const searchWasMade = (queried) => {
    setWasSearched(queried);
  };

  const sendTxFileData = ({month, year, file}) => {
    return new Promise((resolve , reject) => {
      setIsTxDataLoading(true)
      uploadTxFile(month,year,file).then((successData) => {
        hideModal();
        resolve(true)
        window.location.reload(false);
      }).catch((error) =>{
          resolve(error)
          errorToast(error);
      })
    })
  }

  const cancelUploadButtonHandler = () => {
    setIsTxDataLoading(false);
    hideModal();
  }

  const uploadTxFileHandler = () =>{
      showModal({
        title: "Subir archivo operativo",
        body: <UploadTxFileModal handleSubmit={sendTxFileData} />,
        buttons: (
            <>
              <Button
                key="1"
                variant="default"
                onClick={cancelUploadButtonHandler}
              >
                {"Cancelar"}
              </Button>
            </>
        ),
      })
  }

  return (
    <>
      <Row className="justify-content-md-center" style={{paddingRight:"2vw", marginTop: "2vh", background: "var(--bs-primary)"}}>
      {isTxDataLoading && (
                    <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
        )}
        <Col xs={12} className="mb-4 d-none d-sm-block">
          <TxTable
            type="all"
            actions={[
              {
                type: "search",
              },
            ]}
            didSearch={searchWasMade}
            deactivateAll
            uploadTxFile
            uploadTxFileCallback={uploadTxFileHandler}
          />
        </Col>
      </Row>
    </>
  );
}

export default TxPage;
